// extracted by mini-css-extract-plugin
module.exports = {"resource-locator":"resource-locator--tcSXpyy44N","resourceLocator":"resource-locator--tcSXpyy44N","fixed":"fixed--1T2wFJpPoP"};